import { ApiClient } from './api-client';
import { LoggableAPI } from '../models/protocols/loggable-api';
import { LoggingService } from '../services/logging-service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Display } from '../models/display/dto/display';
import { Endpoints } from './endpoints';
import { catchError } from 'rxjs/operators';
import { BsError } from '../models/shared/bs-error';
import { ApiErrorLog } from '../models/shared/api-error-log';
import { WebSocketService } from '../services/web-socket.service';
import { WebSocketRequestDisplay } from '../models/web-sockets/messages/send/web-socket-request-display';

@Injectable({ providedIn: 'root' })
export class DisplayAPI implements LoggableAPI {
  constructor(
    private apiClient: ApiClient,
    private loggingService: LoggingService,
    private webSocketService: WebSocketService
  ) {}

  public serviceName = 'Display';

  public getDisplay$(
    displayId: string,
    includeProducts: boolean,
    ignoreLastSession: boolean,
    lastModified?: number,
    publishToast?: (message: string, title: string) => void
  ): Observable<Display> {
    return this.webSocketGetDisplay$(displayId, includeProducts, ignoreLastSession, lastModified, publishToast);
  }

  protected webSocketGetDisplay$(
    displayId: string,
    includeProducts: boolean,
    ignoreLastSession: boolean,
    lastModified?: number,
    publishToast?: (message: string, title: string) => void
  ): Observable<Display> {
    this.webSocketService.connectToDisplayId(displayId);
    const msg = new WebSocketRequestDisplay(displayId, ignoreLastSession, lastModified);
    return this.webSocketService.requestObject$(msg, Display).pipe(
      catchError(error => {
        const err = new BsError(error, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'GetDisplayFromWebSocket', err));
        return this.restfulGetDisplay$(displayId, includeProducts, ignoreLastSession, lastModified, publishToast);
      })
    );
  }

  protected restfulGetDisplay$(
    id: string,
    includeProducts: boolean,
    ignoreLastSession: boolean,
    lastModified?: number,
    publishToast?: (message: string, title: string) => void
  ): Observable<Display> {
    const url = Endpoints.GetDisplay(id, includeProducts, ignoreLastSession, lastModified);
    const maxRetries = 5;
    return this.apiClient.recursiveGetObjectWithRetry$(Display, url, null, maxRetries, publishToast).pipe(
      catchError(e => {
        const err = new BsError(e, this.serviceName);
        this.loggingService.LogAPIError(new ApiErrorLog(this.serviceName, 'GetDisplay', err));
        return throwError(() => err);
      })
    );
  }
}
